import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLandingContent } from "@/lib/landing/LandingContentProvider";
import { isLongLabel, phoneHref } from "@/lib/landing/resolve";
export default function LandingProcess({
  onBook,
  onCall,
}: {
  onBook: () => void;
  onCall: () => void;
}) {
  const { content } = useLandingContent();
  return (
    <section
      aria-labelledby="process-title"
      className="bg-landing-soft py-14 text-landing-ink sm:py-24"
    >
      <div className="landing-container">
        <p className="landing-eyebrow text-landing-red">{content.process.eyebrow}</p>
        <h2 id="process-title" className="landing-section-title mt-3 max-w-xl">
          {content.process.title}
        </h2>
        <div className="mt-9 grid gap-6 md:grid-cols-3">
          {content.process.steps.map(({ title, text }, i) => (
            <article
              key={i}
              className="rounded-2xl border border-landing-step-border bg-landing-light p-6 sm:p-8"
            >
              <span className="font-display text-[44px] font-bold leading-none text-landing-red">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="mt-4 font-display text-[22px] font-semibold">
                {title}
              </h3>
              <p className="mt-3 text-[16.5px] leading-[1.6] text-landing-light-body">
                {text}
              </p>
            </article>
          ))}
        </div>
        <div className="mt-8 flex flex-wrap items-center gap-5">
          <Button
            onClick={onBook}
            className={`h-[52px] rounded-xl bg-landing-red px-[30px] text-[17px] font-bold sm:h-14 text-primary-foreground hover:bg-landing-red-hover${isLongLabel(content.cta.label) ? " max-w-full whitespace-normal text-left leading-[1.15]" : ""}`}
          >
            {content.cta.label} <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
          <a
            href={phoneHref(content.phone)}
            onClick={onCall}
            className="font-display text-[19px] font-semibold"
          >
            {`or call ${content.phone}`}
          </a>
        </div>
      </div>
    </section>
  );
}
